import React from "react";
import { useTranslation } from "react-i18next";

const StepCount = ({ step }) => {
    // ----------- hooks ------------
    const { t, i18n } = useTranslation();
    return (
        <div
            className={`${
                i18n.language === "ar" && "steps-line"
            } relative flex flex-col gap-14`}
        >
            {[
                "Basic Information",
                "Personal Information",
                "Additional Information",
            ]?.map((item, index) => {
                return (
                    <div className="flex flex-row gap-6 items-center z-50">
                        <div
                            className={`bg-bgGray w-10 h-10 rounded-full text-2xl flex items-center justify-center ${
                                step >= index
                                    ? "bg-purple text-white border-4 border-white p-2 outline outline-1 outline-purple"
                                    : "bg-gray"
                            }`}
                        >
                            {index + 1}
                        </div>
                        <div
                            className={
                                step === index
                                    ? "text-lg font-semibold"
                                    : "text-md font-medium text-gray"
                            }
                        >
                            {t(item)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default StepCount;
